import { Modal, Button, Card, Image, Badge } from "react-bootstrap";
import { faClock, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Breadcrumbs from "./Breadcrumbs";
import "./blog.css";

const BlogPreview = ({ show, handleClose, blog }) => {
  const getBreadcrumbItems = () => {
    return [
      { label: "All Blogs", path: "/blog" },
      { label: blog.category_name, path: `/blog?category=${blog.category_name}` },
      { label: blog.title, active: true }
    ];
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Blog Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="border-0">
          <Card.Body>
            <Breadcrumbs items={getBreadcrumbItems()} />
            
            <h2 className="mb-3">{blog.title}</h2>
            <div className="d-flex align-items-center mb-3 flex-wrap">
              <Badge bg="info" className="category-badge me-3">{blog.category_name}</Badge>
              
              <div className="d-flex align-items-center me-3">
                <FontAwesomeIcon icon={faUser} className="me-1 text-muted" />
                {blog.author.author_profile_link ? (
                  <a href={blog.author.author_profile_link} target="_blank" rel="noopener noreferrer" className="author-link">
                    {blog.created_by}
                  </a>
                ) : (
                  <span className="text-muted">{blog.created_by}</span>
                )}
              </div>
              
              {blog.read_time && (
                <div className="d-flex align-items-center text-muted small">
                  <FontAwesomeIcon icon={faClock} className="me-1" />
                  <span>{blog.read_time}</span>
                </div>
              )}
            </div>
            
            {blog.author_bio && (
              <div className="author-bio mb-4 p-3 bg-light rounded border-start border-primary border-2">
                <small>{blog.author_bio}</small>
              </div>
            )}
            
            {blog.tldr_summary && (
              <div className="tldr-summary mb-4 p-3 bg-light rounded">
                <h6 className="fw-bold mb-2">TL;DR</h6>
                <p className="mb-0">{blog.tldr_summary}</p>
              </div>
            )}
            
            <Image 
              src={blog.image_url} 
              alt={blog.title} 
              fluid 
              className="mb-4" 
              style={{ maxHeight: "300px", objectFit: "cover", width: "100%" }}
            />
            <div className="blog-content">
              {/* Use dangerouslySetInnerHTML to render the HTML content */}
              <div dangerouslySetInnerHTML={{ __html: blog.content }} />
            </div>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BlogPreview; 